module.exports = __webpack_public_path__ + "static/media/softail-high-flow-zoom.4c6147de.png";